import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROLE_HOME_MAP } from "../utils/roleHomeMap";
import { DASHBOARD_EMAIL_ALLOWLIST } from "../utils/allowedDashboardEmails";

const ProtectedRoute = ({
  isAuthenticated,
  redirectTo = "/",
  element,
  allowedRoles = [],
}) => {
  const location = useLocation();

  const role = localStorage.getItem("role");
  const email = localStorage.getItem("email");

  // 1️⃣ Not authenticated
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // 2️⃣ Email-based dashboard restriction
  if (
    ["/dashboard", "/trezi-dashboard"].includes(location.pathname)
  ) {
    const isAllowed =
      role === "Owner" &&
      DASHBOARD_EMAIL_ALLOWLIST.includes(email?.toLowerCase());

    if (!isAllowed) {
      return <Navigate to={ROLE_HOME_MAP[role] || redirectTo} replace />;
    }
  }

  // 3️⃣ Role-based restriction
  if (allowedRoles.length && !allowedRoles.includes(role)) {
    return <Navigate to={ROLE_HOME_MAP[role] || redirectTo} replace />;
  }

  // 4️⃣ Strict dashboard isolation
  const roleHome = ROLE_HOME_MAP[role];

  if (
    roleHome &&
    location.pathname !== roleHome &&
    !["/dashboard", "/trezi-dashboard"].includes(location.pathname)
  ) {
    return <Navigate to={roleHome} replace />;
  }

  return element;
};

export default ProtectedRoute;
